module.exports = __webpack_public_path__ + "img/dsd.e8216fab.png";